<template>
    <div class="dashboard-container">
      <div class="filter-section-user">
        <!-- 时间筛选区域 -->
        <div class="filter-section">
          <el-form :inline="true"  class="demo-form-inline">
            <el-form-item label="产品SKU">
              <el-input style="width:200px"  v-model="SearchMaterialNumber" placeholder="SKU" clearable />
            </el-form-item>
            <el-form-item label="销售订单创建时间">
              <el-date-picker
                  value-format="YYYY-MM"
                  format="YYYY-MM"
                  v-model="startMonth"
                  type="month"
                  placeholder="起始时间"
                  clearable
              />
              -
              <el-date-picker
                  value-format="YYYY-MM"
                  format="YYYY-MM"
                  v-model="endMonth"
                  type="month"
                  placeholder="结束时间"
                  clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getOrderData">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="days">平均生产用时时间(天): <span style="color:#f56c6c" >{{days}}</span> </div>
      <!-- <p>{{ selectName }}的销售订单</p> -->
      <!-- 订单列表区域 -->
      <div class="order-list">
          <el-table :data="orders" style="width: 100%" @sort-change="handleSortChange">
              <el-table-column prop="BillNo" label="销售订单编码" min-width="80" />
              <el-table-column prop="MaterialName" label="成品名称" min-width="100" show-overflow-tooltip />
              <el-table-column prop="MaterialNumber" label="物料编码" min-width="100" show-overflow-tooltip />
              <el-table-column prop="Qty" label="下单数量" min-width="50" align="center" />
              <el-table-column prop="out_sum" label="已出库数量" min-width="60" align="center" />
              <el-table-column prop="crete_date" label="下单时间" min-width="80" align="center" />
              <el-table-column label="生产订单" min-width="300">
                <template #default="scope">
                  <div class="produce_order_list"  v-for="(item,index) in scope.row.others" :key="index" >
                    <div style="flex:4" >生产单号:{{item.BillNo}}</div>
                    <div style="flex:3" >生产用时(天): <span style="color:#f56c6c">{{item.tempDays}}</span>   </div>
                    <div style="flex:3" >生产数量: {{item.Qty}}</div>
                    <div style="flex:5" >完结时间:{{item.FinishDate}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="要货时间" min-width="80" prop="DeliveryDate" :formatter="formatDate" />
              <el-table-column prop="CloseStatus" label="业务状态" min-width="60" show-overflow-tooltip />
          </el-table>
      </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import dayjs from "dayjs";
import {getDateMonth} from "../../../public/js/index.js";
import {ElTable,ElTableColumn,ElButton,ElInput,ElDatePicker} from "element-plus";
import {getOrderOriginal} from "@/utils/api";
const nowdate = new Date();
const end = getDateMonth(nowdate);
nowdate.setTime(nowdate.getTime() - 3600 * 1000 * 24 * 30 * 3)
const start = getDateMonth(nowdate) ;

console.log(start,end)
// 查询参数
const SearchMaterialNumber = ref("");
const startMonth = ref(start);
const endMonth = ref(end);
const days = ref("暂无匹配时间");
const OrderBy = ref("PlanStartDate");

// 响应参数
const total = ref(0);

const orders = ref([]);




const buildParams = () => {
    let params = {
        MaterialNumber: SearchMaterialNumber.value,
        startMonth: startMonth.value,
        endMonth: endMonth.value,
    };
    return params;
};
// 获取订单方法
const getOrderData = async () => {
    let params = buildParams();
    getOrderOriginal(params).then(res=>{
      if (res.Code === 0) {
        orders.value = res.Data;
        days.value = res.aveDays;
        total.value = res.Total;
      }
    }).catch(err=>{
      console.log(err)
    });

};



const formatDate = (row, column, cellValue) => {
    if (cellValue) {
        // 检查 cellValue 是否为 Date 对象
        if (cellValue instanceof Date) {
            return dayjs(cellValue).format("YYYY-MM-DD");
        }
        // 假设 cellValue 是字符串
        return cellValue.slice(0, 10);
    }
    return "-";
};


const handleSortChange = ({ column, order }) => {
    const sortOrder = order;
    const columnName = column.property;
    if (sortOrder === "descending") {
        OrderBy.value = "-" + columnName;
    } else {
        OrderBy.value = columnName;
    }
    getOrderData();
};


onMounted(() => {
    // 组件挂载时使用默认时间范围获取数据
    // handleDateChange(dateRange.value);
    // getOrderData();
});
</script>

<style scoped>
.dashboard-container {
    padding: 24px;
    background-color: #f5f7fa;
    min-height: 100vh;
    min-height: 100vh;
    height: 100vh;
    /* 添加固定高度 */
    overflow: hidden;
    /* 防止整个页面出现滚动条 */
}
.filter-section-user{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-dialog__body {
    padding: 0 !important;
}

/* 卡片样式优化 */
:deep(.el-card) {
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    transition: all 0.3s;
}

:deep(.el-card:hover) {
    box-shadow: 0 4px 12px rgba(0, 21, 41, 0.12);
}

:deep(.el-card__header) {
    padding: 16px 20px;
    border-bottom: 1px solid #ebeef5;
    background-color: #fafafa;
}

/* 统计卡片样式 */
.stats-cards {
    margin-bottom: 5px;
}

.stats-card {
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid transparent;
}

.stats-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stats-card.is-active {
    border-color: #409eff;
    background-color: rgba(64, 158, 255, 0.05);

    .number {
        color: #409eff;
    }

    .item-title {
        color: #409eff;
        font-weight: 600;
    }
}

.stats-card .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

.stats-card .number {
    font-size: 28px;
    font-weight: 600;
    color: #606266;
    margin: 8px 0;
    line-height: 1;
    transition: color 0.3s;
}

.stats-card .item-title {
    margin: 0;
    font-size: 14px;
    color: #606266;
    font-weight: 500;
    transition: all 0.3s;
}

/* 订单卡片样式 */
.order-card {
    margin-bottom: 16px;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    /* 选中状态样式 */
    &.is-selected {
        box-shadow: 0 0 0 2px var(--el-color-primary);
        background-color: var(--el-color-primary-light-9);

        /* 根据状态调整选中时的阴影颜色 */
        &.status-normal {
            box-shadow: 0 0 0 2px var(--el-color-success);
        }

        &.status-error {
            box-shadow: 0 0 0 2px var(--el-color-danger);
        }

        &.status-pending {
            box-shadow: 0 0 0 2px var(--el-color-warning);
        }

        &.status-expired {
            box-shadow: 0 0 0 2px var(--el-color-info);
        }
    }

    /* 其他状态样式保持不变 */
    &.status-normal {
        border-left-color: var(--el-color-success);
    }

    &.status-error {
        border-left-color: var(--el-color-danger);
    }

    &.status-pending {
        border-left-color: var(--el-color-warning);
    }

    &.status-expired {
        border-left-color: var(--el-color-info);
    }
}

.order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.order-no {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.order-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.order-info {
    margin: 8px 0;
    color: #606266;
    line-height: 1.6;
}

.order-info .label {
    color: #909399;
    margin-right: 8px;
}

/* 表单样式优化 */
:deep(.el-form-item__label) {
    font-weight: 500;
    color: #606266;
}

:deep(.el-input__wrapper),
:deep(.el-textarea__inner) {
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    transition: all 0.3s;
}

:deep(.el-input__wrapper:hover),
:deep(.el-textarea__inner:hover) {
    box-shadow: 0 0 0 1px #c0c4cc inset;
}

:deep(.el-input__wrapper.is-focus),
:deep(.el-textarea__inner:focus) {
    box-shadow: 0 0 0 1px #409eff inset;
}

/* 评论区样式优化 */
.comments-list {
    padding: 20px;
    max-height: 400px;
    overflow-y: auto;
}

.comment-item {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
}

.comment-item:hover {
    background-color: #f0f2f5;
    transform: translateX(4px);
}

.comment-item:last-child {
    margin-bottom: 0;
    border-bottom: none;
}

.comment-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.comment-avatar {
    background-color: #409eff;
    color: #fff;
    font-weight: 600;
}

.comment-author {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
}

.comment-time {
    color: #909399;
    font-size: 12px;
    margin-left: auto;
}

.comment-content {
    color: #606266;
    line-height: 1.8;
    font-size: 14px;
    padding: 0 4px;
}

.add-comment {
    padding: 20px 0 20px 0;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.04);
}

.add-comment :deep(.el-textarea__inner) {
    padding: 12px;
    font-size: 14px;
    border-radius: 4px;
    resize: none;
    background-color: #f8f9fa;
    border: none;
    transition: all 0.3s;
}

.add-comment :deep(.el-textarea__inner:focus) {
    background-color: #fff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.add-comment :deep(.el-button) {
    margin-top: 16px;
    height: 40px;
    font-size: 14px;
    letter-spacing: 1px;
    transition: all 0.3s;
}

.add-comment :deep(.el-button:hover) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

/* 自定义滚动条样式 */
.comments-list::-webkit-scrollbar {
    width: 6px;
}

.comments-list::-webkit-scrollbar-thumb {
    background-color: #dcdfe6;
    border-radius: 3px;
}

.comments-list::-webkit-scrollbar-track {
    background-color: #f8f9fa;
}

/* 标签样式 */
:deep(.el-tag) {
    border-radius: 4px;
    padding: 0 8px;
    height: 24px;
    line-height: 22px;
}

/* 按钮样式 */
:deep(.el-button) {
    padding: 8px 20px;
    font-weight: 500;
    border-radius: 4px;
}

/* 抽屉样式 */
:deep(.el-drawer__header) {
    margin-bottom: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #ebeef5;
}

:deep(.el-drawer__body) {
    padding: 20px;
}

/* 对话框样式 */
:deep(.el-dialog__header) {
    padding: 20px;
    margin-right: 0;
    border-bottom: 1px solid #ebeef5;
}

:deep(.el-dialog__body) {
    padding: 24px;
}

:deep(.el-dialog__footer) {
    padding: 16px 20px;
    border-top: 1px solid #ebeef5;
}

/* 用户信息样式 */
.header-user-info {
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 100;
}

.user-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s;
}

.user-wrapper:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.username {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
}

/* 消息样式 */
.message-badge {
    margin-right: 8px;
}

.message-list {
    padding: 16px;
}

.message-item {
    padding: 16px;
    border-bottom: 1px solid #ebeef5;
    transition: background-color 0.3s;
}

.message-item:hover {
    background-color: #f5f7fa;
}

.message-title {
    font-weight: 600;
    color: #303133;
    margin-bottom: 8px;
}

.message-content {
    color: #606266;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 8px;
}

.message-time {
    color: #909399;
    font-size: 12px;
}

.notice-count {
    margin-left: 8px;
}

.is-favorite {
    color: #f7ba2a;
}

.show-detail {
    cursor: pointer;
}

.po-detail-tooltip {
    cursor: pointer;
    color: #409eff;
}

.main-title {
    width: 100%;
    margin: 0 auto;
}

/* 订单详情对话框样式 */
:deep(.el-dialog) {
    border-radius: 8px;
    box-shadow: 0 12px 32px 4px rgba(0, 0, 0, 0.04),
        0 8px 20px rgba(0, 0, 0, 0.08);
}

:deep(.el-dialog__title) {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}

.order-detail {
    padding: 0;
}

/* 详情表格样式 */
.order-detail :deep(.el-table) {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.order-detail :deep(.el-table__header-wrapper) {
    background-color: #f5f7fa;
}

.order-detail :deep(.el-table__header th) {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
    height: 48px;
}

.order-detail :deep(.el-table__row) {
    transition: all 0.3s;
}

.order-detail :deep(.el-table__row:hover) {
    background-color: #f5f7fa;
}

.order-detail :deep(.el-table__row td) {
    padding: 12px 0;
}
.produce_order_list{
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}

.days{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 500;
  color: #606266;
  font-size: 16px;
  margin-bottom: 10px;
}

/* 状态标签样式 */
.order-detail :deep(.el-tag) {
    border-radius: 4px;
    padding: 0 12px;
    height: 28px;
    line-height: 26px;
    font-weight: 500;
}



/* 详情页脚样式 */
:deep(.el-dialog__footer) {
    background-color: #f8f9fa;
    border-radius: 0 0 8px 8px;
}

:deep(.el-dialog__footer .el-button) {
    min-width: 100px;
}

.follow-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    padding: 20px 20px 20px 0;
    margin-right: 0;
    border-bottom: 1px solid #ebeef5;
}

.no-padding {
    padding: 0 !important;
}

.filter-section {
    margin-bottom: 15px;
}

.order-list {
    margin-bottom: 30px;
    overflow-y: auto;
    /* 根据需要调整高度 */
    flex: 1;
    /* 占用剩余空间 */
    display: flex;
    flex-direction: column;
    min-height: 0;
    /* 重要:允许flex item收缩 */
}

/* 表格样式优化 */
:deep(.el-table) {
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    transition: all 0.3s;
    flex: 1;
    height: 100% !important;
    table-layout: fixed;
}

:deep(.el-table:hover) {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

:deep(.el-table__header-wrapper) {
    background-color: #f5f7fa;
}

:deep(.el-table__header th) {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
    height: 48px;
}

:deep(.el-table__row) {
    transition: all 0.3s;
    height: 48px;
    line-height: 48px;
}

:deep(.el-table__row:hover) {
    background-color: #f5f7fa;
}

:deep(.el-table__row td) {
    padding: 12px 0;
}

:deep(.el-tag) {
    border-radius: 4px;
    padding: 0 8px;
    height: 24px;
    line-height: 22px;
    font-weight: 500;
    cursor: pointer;
}

/* 分页器样式 */
:deep(.el-pagination) {
    padding: 20px 0;
    background: white;
    border-top: 1px solid #ebeef5;
    margin-top: auto;
    /* 确保分页器在底部 */
}

/* 优化分页器在小屏幕上的显示 */
@media screen and (max-width: 768px) {
    :deep(.el-pagination) {
        .el-pagination__sizes {
            display: none;
        }
    }
}

.page-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 优化表格内容样式 */
:deep(.el-table__cell) {
    padding: 8px;

    .cell {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

/* 数字列右对齐 */
:deep(.el-table__column--align-right) {
    text-align: right;

    .cell {
        padding-right: 12px;
    }
}
</style>